import React from "react";
import BwvCards from "../BwvCards";
import LcaBox from "../LcaBox";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ChatModal from "../../modals/ChatModal";
import {
  setMessages,
  setSelectedConversation,
} from "../../../../redux/slices/MsgSlice";
import {
  setIsMsgModalOpen,
  setSelectedAd,
} from "../../../../redux/slices/LcaSlice";
import BwvBox from "../BwvBox";

const VendorCards = ({ allProducts, currentVendors, carouselData }) => {
  const navigate = useNavigate();
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const dispatch = useDispatch();
  const user = islogin ? JSON.parse(userinfo) : null;
  const { selectedAd, isMsgModalOpen, finalProducts, selectedSubCategory } =
    useSelector((state) => state.lcAds);
  const verifiedLcaBox = allProducts.filter((ad) => ad.caIdStatus === 100);
  const unverifiedLcaBox = allProducts.filter((ad) => ad.caIdStatus !== 100);
  const verifiedBwvBox = currentVendors.filter((ad) => ad.caIdStatus === 100);
  const unverifiedBwvBox = currentVendors.filter((ad) => ad.caIdStatus !== 100);

  const closeModal = () => {
    dispatch(setSelectedConversation(null));
    dispatch(setIsMsgModalOpen(false));
    dispatch(setSelectedAd(null));
    dispatch(setMessages(null));
  };

  if (
    !verifiedLcaBox.length &&
    !unverifiedLcaBox.length &&
    !currentVendors.length
  ) {
    return (
      <div
        className="text-center py-5 text-primary"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "50px 0px",
        }}
      >
        <p
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "10px 0px",
            fontSize: "20px",
          }}
          className="text-center py-5"
        >
          No cards to display
        </p>
      </div>
    );
  }

  return (
    <>
      {verifiedBwvBox.map((ad) => (
        <div key={ad.Id} style={{ cursor: "pointer" }}>
          <p
            className="mb-1"
            style={{ fontSize: "medium" }}
            onClick={() => {
              islogin
                ? navigate(`/userDetails/${ad.createdBy}`)
                : toast.info("Please login to view profile");
              console.log(ad, "userDetails");
            }}
          >
            {ad?.FullName}
          </p>
          <BwvBox ad={ad} />
        </div>
      ))}
      {verifiedLcaBox.map((ad) => (
        <div key={ad.Id} style={{ cursor: "pointer" }}>
          <p
            className="mb-1"
            style={{ fontSize: "medium" }}
            onClick={() => {
              islogin
                ? navigate(`/userDetails/${ad.createdBy}`)
                : toast.info("Please login to view profile");
              console.log(ad, "userDetails");
            }}
          >
            {ad?.FullName}
          </p>
          <LcaBox ad={ad} />
        </div>
      ))}
      <BwvCards currentVendors={unverifiedBwvBox} carouselData={carouselData} />
      <ChatModal
        isOpen={isMsgModalOpen}
        closeModal={closeModal}
        ad={selectedAd}
      />
    </>
  );
};

export default VendorCards;
